import axios from 'axios';

const http = axios.create({
  timeout: 50 * 1000,
  headers: {Accept: 'application/json'}
});

const fullPath = (relativePath) => {
  return ROOT_PATH + relativePath;
};

export const post = (url, body, headers = {}) => {
  return http.post(fullPath(url), body, {headers});
};
